// extracted by mini-css-extract-plugin
export var active = "_d6-2";
export var recordingDot = "_d6-1";
export var recordingIndicator = "_d6-0";